export default{
    methods:{
        textOverride(intext){
            if(intext.includes('Student')){
                if(window.TEXT_OVERRIDE_STUDENT==undefined){return intext}
                    
                let replaceText = window.TEXT_OVERRIDE_STUDENT
                intext = intext.replaceAll('Student',replaceText)
                
            }else if(intext.includes('student')){
                if(window.TEXT_OVERRIDE_STUDENT==undefined){return intext}
                    
                let replaceText = window.TEXT_OVERRIDE_STUDENT.toLowerCase()
                intext = intext.replaceAll('student',replaceText)
            }
            return intext
        },
    }
}